// 教程系统已移除 - 此文件仅为保持兼容性
export const CATEGORIES = {};

export default {};
